import { Defaults } from 'es-decorators'
import { getTemplate } from 'helpers/template-helper'
import { View } from 'es6/components/view'
import { Popup } from 'es6/libs/popup'
import $ from 'init/jquery'
import { KEY_CODES } from 'es6/constants'

/**
 * Вью подсказок по банкам
 */
@Defaults({
  el: '.js-input-with-tips-wrap',
  events: {
    'click .tip': 'onTipClick',
    'keydown': 'onTipsKeydown',
  },
  withTipsPopup: true,
  additionalOptions: ['applyTip', 'withTipsPopup'],
  tipsTemplateId: '#tips-template',
  selectedTipIdx: -1,
})
export class BankDaDataTipsView extends View {
  /**
   * @inheritDoc
   */
  run () {
    if (this.withTipsPopup) {
      this.$tipPlace = this.$('#tip-place')
      this.tipsTemplate = getTemplate(this.tipsTemplateId)
      this.popup = new Popup(this.$tipPlace, this.$tipPlace)
    }
  }

  /**
   * Показывает/скрывает попап с подсказками по банкам
   */
  toggleTipsPopup () {
    if (this.tipsData && this.tipsData.length) {
      this.$tipPlace.html(this.tipsTemplate({ tips: this.tipsData }))
      if (this.popup.isClosed()) {
        this.popup.open()
      } else {
        this.selectedTipIdx = -1
      }
    } else {
      this.popup.close()
      this.$el.off('keydown', this.onTipsKeydown.bind(this))
      this.selectedTipIdx = -1
    }
  }

  /**
   * Обработка клика на подсказке
   * @param {Object} event Событие клика
   */
  onTipClick (event) {
    const value = event.currentTarget.innerText.trim()
    const tipInfo = this.tipsData.find(obj => obj.value === value)
    if (tipInfo && tipInfo.data) {
      this.chooseTip(tipInfo.data)
    }
  }

  /**
   * Подставляет данные подсказки в форму
   * @param {Object} tip Подсказка
   */
  chooseTip (tip) {
    if (tip) {
      this.popup && this.popup.close()
      this.selectedTipIdx = -1
      this.applyTip(tip)
    }
  }

  /**
   * Выделяет активную подсказку и снимает выделение с предыдущей подсказки
   * @param {HTMLElement} currentTip Текущая подсказка
   */
  makeTipActive (currentTip) {
    this.$('.tip.active').removeClass('active')
    $(currentTip).addClass('active')
  }

  /**
   * Обработка нажатия клавиш
   * @param {Object} event Событие keydown
   */
  onTipsKeydown (event) {
    const tips = this.$('.tip')
    switch (event.keyCode) {
      case KEY_CODES.ArrowUp:
        if (this.selectedTipIdx > 0) {
          this.selectedTipIdx--
          this.makeTipActive(tips[this.selectedTipIdx])
        }
        break
      case KEY_CODES.ArrowDown:
        if (this.selectedTipIdx < tips.length - 1) {
          this.selectedTipIdx++
          this.makeTipActive(tips[this.selectedTipIdx])
        }
        break
      case KEY_CODES.Enter:
        event.preventDefault()
        if (this.selectedTipIdx >= 0 && this.tipsData[this.selectedTipIdx]) {
          this.chooseTip(this.tipsData[this.selectedTipIdx].data)
        }
        break
    }
  }

  /**
   * Запрос подсказок по банкам DaData
   * @param {string} query Строка запроса
   */
  tipsRequest (query) {
    $.ajax({
      url: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/bank',
      type: 'POST',
      headers: {
        'Authorization': 'Token 456b824510e1ccf20fb23f1e5695179a9a38dab1',
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      data: JSON.stringify({ query: query }),
      success: this.onTipsReceived.bind(this),
    })
  }

  /**
   * Выполняется при получении подсказок с DaData
   * @param {Object} data - обьект ответа с DaData
   */
  onTipsReceived (data) {
    this.tipsData = data.suggestions
    if (this.withTipsPopup) {
      this.toggleTipsPopup()
    } else if (this.tipsData) {
      if (this.tipsData.length === 1) {
        this.chooseTip(this.tipsData[0].data)
      } else if (this.tipsData.length === 0) {
        this.applyTip({})
      }
    }
  }
}
